import { ChakraProvider, extendTheme } from '@chakra-ui/react'
import * as React from 'react'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import * as ReactDOM from 'react-dom'
import { HelmetProvider } from 'react-helmet-async'
import App from './app'
import { MLWidgetProvider } from './app/contexts/MLWidgetContext'
import PublicLinkPasswordPage from './app/pages/PublicLink/PublicLinkPasswordPage'
import { CSRFProvider } from './app/providers'
import { PublicLinksInfoProvider } from './app/providers/PublicLinksInfoProvider'
import './locales/i18n'
import { theme } from './ui-kit'

const MOUNT_NODE = document.getElementById('root')

window.trackEvent = ({
  action,
  category,
  label,
  value,
  fields = [],
}: {
  action?: string
  category?: string
  label: string
  value?: number
  fields?: any[]
}): void => {
  try {
    if (label && 'fbq' in window) {
      setTimeout(() => {
        window.fbq('trackCustom', label)
      }, 0)
    }
    if ('ga' in window) {
      const trackers = window.ga.getAll()
      if (trackers.length > 0) {
        const tracker = trackers[0]
        if (fields.length > 0) {
          tracker.send('event', ...fields)
        } else {
          tracker.send('event', 'Custom', label)
        }
      }
    }
    if ('gtag' in window) {
      window.gtag('event', action ?? 'Custom', {
        event_label: label,
        event_category: category,
        value,
      })
    }
  } catch (ex) {}
}

ReactDOM.render(
  <ChakraProvider theme={extendTheme(theme, { styles: { global: { html: { overflow: 'hidden' } } } })}>
    <HelmetProvider>
        <CSRFProvider>
          <PublicLinksInfoProvider>
            <React.StrictMode>
              <MLWidgetProvider>
                {
                  window.publicLinkInfo?.isAuthenticated ? (
                    <App />
                  ) : (
                    <PublicLinkPasswordPage />
                  )
                }
              </MLWidgetProvider>
            </React.StrictMode>
          </PublicLinksInfoProvider>
        </CSRFProvider>
    </HelmetProvider>
  </ChakraProvider>,
  MOUNT_NODE,
)

// Will only be when run via webpack dev server
if (module.hot) {
  // Honor Translation files for hot reload
  module.hot.accept()
}
